<template>
  <router-view />
  <div v-if="userStore.authBootstrapping" class="auth-loading-shell" aria-busy="true" aria-live="polite">
    <LoadingSpinner />
  </div>
  <Idle v-if="userStore.loggedIn" />
</template>

<style lang="scss">
@import 'src/scss/app.scss';

.auth-loading-shell {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.88);
}
</style>
<script setup lang="ts">
import Idle from '@/Idle.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
</script>
